export enum KeywordsRoutes {
  root = 'keywords',
  create = 'create',
  edit = 'edit',
  clone = 'clone',
  view = 'view',
}
